Vendd.Scripts.load(function () {

    var run = function () {
        $('.x-control.x-map[data-control="map"]').each(function (i, wrapper) {
            var $wrapper = $(wrapper);

            var config = {};

            wrapper.mapOpts = {
                zoom: 13,
                maxZoom: 19,
                scrollwheel: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                streetViewControl: false,
                mapTypeControl: false
            };

            wrapper.infoWinOpts = {
                maxWidth: 440
            };

            wrapper.markerOpts = {
                title: LhApp.Context.Site.Name,
                icon: $wrapper.data('marker')
            };

            wrapper.map = null;

            wrapper.markers = [];

            wrapper.markerCluster = null;

            wrapper.create = function (coordinates) {
                var coords = [];

                $(coordinates).each(function (c, cc) {
                    var existsCoord = coords.find(function (x) { return x.lat === cc.lat && x.lng == cc.lng });
                    if (!existsCoord)
                        coords.push(cc);
                });

                if (coords.length == 0)
                    throw new Error('no coordinates');

                var firstLatLng = coords[0];

                var mapOpts = {};
                $.extend(true, mapOpts, wrapper.mapOpts, {
                    div: '#' + $wrapper.attr('id'),
                    lat: firstLatLng.lat,
                    lng: firstLatLng.lng
                });

                wrapper.map = new GMaps(mapOpts);

                wrapper.addMarkers(coords);
            };

            wrapper.reinit = function (coordinates) {
                var coords = [];

                if (coordinates) {
                    $(coordinates).each(function (c, cc) {
                        var existsCoord = coords.find(function (x) { return x.lat === cc.lat && x.lng == cc.lng });
                        if (!existsCoord)
                            coords.push(cc);
                    });

                    wrapper.addMarkers(coords);
                } 
            };

            wrapper.setCenter = function () {
                if (wrapper.markers.length == 0) {
                    wrapper.map.setZoom(3);
                    return;
                }

                if ($(".contact-page").length > 0 && wrapper.markers.length == 1) {
                    wrapper.map.setZoom(15);
                    return;
                }
               
                if (wrapper.markers.length == 1) {
                    wrapper.map.setZoom(15);
                } else {
                    var bounds = new google.maps.LatLngBounds();
                    for (i = 0; i < wrapper.markers.length; i++) {
                        bounds.extend(wrapper.markers[i].getPosition());
                    }
                    wrapper.map.fitBounds(bounds);
                }
            }

            wrapper.getMarker = function (coordinates) {
                var marker = wrapper.markers.find(function (x) { return x.position.toString() === new google.maps.LatLng(coordinates.lat, coordinates.lng).toString() });
                return marker;
            };

            function find_closest_marker(lat1, lon1) {
                var pi = Math.PI;
                var R = 6371; //equatorial radius
                var distances = [];
                var closest = -1;

                for (i = 0; i < wrapper.markers.length; i++) {
                    var lat2 = wrapper.markers[i].position.lat();
                    var lon2 = wrapper.markers[i].position.lng();

                    var chLat = lat2 - lat1;
                    var chLon = lon2 - lon1;

                    var dLat = chLat * (pi / 180);
                    var dLon = chLon * (pi / 180);

                    var rLat1 = lat1 * (pi / 180);
                    var rLat2 = lat2 * (pi / 180);

                    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                                Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(rLat1) * Math.cos(rLat2);
                    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    var d = R * c;

                    distances[i] = d;
                    if (closest == -1 || d < distances[closest]) {
                        closest = i;
                    }
                }

                return wrapper.markers[closest];
            }

            wrapper.findMarker = function (search, country, callback) {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'address': search + ', ' + (country || 'GR') }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var latLng = results[0].geometry.location;
                        var closestMarker = find_closest_marker(latLng.lat(), latLng.lng());
                        callback(closestMarker, null);
                    } else {
                        callback(null, new Error('closest marker not found'));
                    }
                });
            };

            wrapper.removeMarkers = function () {
                wrapper.markerCluster.clearMarkers();
                wrapper.map.removeMarkers();
                wrapper.markers = [];
            };

            wrapper.addMarkers = function (coords) {

                var openedInfoWindow;

                $(coords).each(function (i, spot) {
                    var infoWindow = null;
                    if (spot.html && spot.html != '') {
                        var infoWindowOpts = {};
                        $.extend(true, infoWindowOpts, wrapper.infoWinOpts, {
                            content: spot.html
                        });
                        infoWindow = new google.maps.InfoWindow(infoWindowOpts);
                    }

                    var markerOpts = {};

                    if (spot.type === 'Service Only') {
                        wrapper.markerOpts.icon = $wrapper.data('marker-two'); 
                    } 
                    else if (spot.type === 'Sales/Service') {
                        wrapper.markerOpts.icon = $wrapper.data('marker-three');
                    } else {
                        wrapper.markerOpts.icon = $wrapper.data('marker'); 
                    }

                    $.extend(true, markerOpts, wrapper.markerOpts, {
                        lat: spot.lat,
                        lng: spot.lng,
                        infoWindow: infoWindow
                    });

                    var marker = wrapper.map.addMarker(markerOpts);
                    wrapper.markers.push(marker);

                    if ($('.x-store-locator').length > 0 || $('.x-map-view').length > 0) {
                        google.maps.event.addListener(marker, 'click', function () {
                            if (typeof openedInfoWindow != 'undefined' && openedInfoWindow) {
                                openedInfoWindow.close();
                                openedInfoWindow = null;
                            }
                            wrapper.map.setZoom(15);
                            wrapper.map.map.panTo(marker.getPosition());
                            wrapper.map.map.setCenter(marker.getPosition());

                            if ($('.home-page').length > 0) {
                                if ($(window).width() > 1079) {
                                    wrapper.map.panBy(-340, -70);
                                } else {
                                    wrapper.map.panBy(0, 120);
                                }
                            } else {
                                wrapper.map.panBy(0, -70);
                            }
                            
                            setTimeout(function () { infoWindow.open(wrapper.map.map, marker); }, 500);
                            openedInfoWindow = infoWindow;
                        });
                    }

                    if ($(".contact-page").length > 0 || $(".product-details-region").length > 0 || $(".store-page").length > 0) {
                        infoWindow.open(wrapper.map.map, marker);
                        wrapper.map.panBy(0, -120);
                    }

                });

                if ($('.x-store-locator').length > 0 || $('.x-map-view').length > 0) {
                    var clusterStyles = [
                        {
                            url: '/themes/templatethemeTwo/images/grouped-markers.png',
                            height: 58,
                            width: 44,
                            textSize: 16,
                            textHeight: 47,
                            textColor: 'white',
                        },

                    ];

                    mcOptions = { gridSize: 70, maxZoom: 10, styles: clusterStyles };

                    wrapper.markerCluster = new MarkerClusterer(wrapper.map.map, wrapper.markers, mcOptions);

                    google.maps.event.addListener(wrapper.markerCluster, 'clusteringend', function () {
                        $('.cluster img:not([alt])').attr('alt', 'cluster marker');
                    });
                }

                wrapper.setCenter();
            };

            wrapper.open = function (marker) {
                google.maps.event.trigger(marker, 'click');
            };
        });
    };

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.GoogleMapsLoaded, 'mapControl', run);
});